var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Stopwords are words that are filtered out before processing any of your text. None of the words in the stopword list will appear in your topic model for an analysis.")])}
var staticRenderFns = []

export { render, staticRenderFns }